import { useSyncExternalStore } from 'react'

// Reactive `navigator.onLine` via the browser's online/offline events, so
// consumers update live rather than freezing at the value read on first render.
function subscribeOnline(onChange: () => void): () => void {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

/**
 * Lives in ~/hooks (not ~/pages/Status) so shared consumers like
 * useConnectionEventLog don't import from a page module — that inverts the
 * dependency direction and would pull the diagnostics page into the main
 * bundle if Status/ is ever lazy-loaded.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribeOnline,
    () => navigator.onLine,
    () => true,
  )
}
